import { useRouter } from "next/router";

import {
  useSearchContext,
  useSearchData,
} from "@/features/search/context/SearchContext";
import { buildIntentHeading } from "@/features/search/utils/intent-heading.utils";
import { Heading } from "@/ui/cva/Heading";

/**
 * The page's `<h1>` — a landing page's own title, or the localized sentence the service
 * builds for a query search ("Search results for chair").
 *
 * Read off the search response rather than threaded down as a prop, so it tracks a client-side
 * refetch, and so `SearchLayout` stays assembly. `size="h5"` matches the old PLP: an `h1` for
 * the document outline, not 48px of category name above the grid. Vintage style pages carry the
 * market's intent wording (WHO-5761, see `intent-heading.utils.ts`).
 */
export const PageTitle = () => {
  const { locale } = useRouter();
  const { route } = useSearchContext();
  const title = useSearchData()?.meta.page?.title;

  if (!title) {
    return null;
  }

  const path = route.kind === "page" ? route.params.url : undefined;

  return (
    <Heading as="h1" size="h5" className="break-words">
      {buildIntentHeading(title, path, locale)}
    </Heading>
  );
};
